import { get } from "lodash";
import { RaceOdds } from "@tvg/ts-types/Race";

export const formatOdds = (currentOdd: RaceOdds) =>
  get(currentOdd, "denominator")
    ? `${get(currentOdd, "numerator", 0)}/${get(currentOdd, "denominator")}`
    : get(currentOdd, "numerator", 0);
